<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-8">
            <div class="d-flex usercontrol">
                <h1>Holiday Master</h1>
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/admin/parameterMaster">Parameter Master</a></li>
                    <li class="active"><a routerLink="/admin/parameterMaster/holiday" aria-current="page">
                            Holiday Master</a></li>
                </ul>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="d-flex justify-content-end usercontrol">
                <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#addHoliday"
                    (click)="resetHolidayForm()">Add Holiday</button>
                <button class="btn btn-primary ml-2" type="button" data-toggle="modal" data-target="#bulkUpload"
                    (click)="resetUploadForm()">Bulk Upload</button>
            </div>
        </div>
    </div>
    <div id="accordion" class="mb-1">
        <div class="card">
            <div class="card-header pointer" id="memberheading">
                <h3 data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
                    aria-controls="collapseFilter">
                    <i class="fa fa-angle-down pull-right customIcon mr-2"></i>Advanced Search
                </h3>
            </div>
            <div id="collapseFilter" class="collapse show" aria-labelledby="memberheading" data-parent="#accordion">
                <div class="card card-body">
                    <form [formGroup]="searchHolidayForm" (ngSubmit)="getHolidayList()">
                        <div class="row align-items-end mx-n2">                
                          
                          <div class="col-lg-3 col-md-4 col-sm-6 form-group px-2">
                            <label>Year<span class="text-danger">*</span></label>
                            <div class="input-group">
                              <input type="text" class="form-control form-control-sm"
                                     formControlName="hldYear" bsDatepicker
                                     [bsConfig]="{minMode: 'year', dateInputFormat: 'YYYY'}"
                                     placeholder="Select Year">
                              <div class="input-group-append">
                                <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                              </div>
                            </div>
                          </div>
                      
                          <div class="col-lg-3 col-md-4 col-sm-6 form-group px-2">
                            <label>Holiday Type<span class="text-danger">*</span></label>
                            <select class="form-control form-control-sm" formControlName="hldType">
                              <option value="" disabled selected>Select Holiday Type</option>
                              <option value="">ALL</option>
                              <option *ngFor="let data of holidayTypes" [value]="data">{{data}}</option>
                            </select>
                          </div>
                      
                          <div class="col-lg-3 col-md-4 col-sm-6 form-group px-2">
                            <label>Currency Segment<span class="text-danger">*</span></label>
                            <select class="form-control form-control-sm" formControlName="currencySegment">
                              <option value="" disabled selected>Select Currency Segment</option>
                              <option *ngFor="let data of currencyList" [value]="data.currencyCode">
                                {{data.currencyCode}} - {{data.currency}}
                              </option>
                            </select>
                          </div>
                      
                          <div class="col-lg-3 col-md-12 form-group px-2 d-flex align-items-end">
                            <button type="submit" class="btn btn-primary btn-sm mr-2">Search</button>
                            <button type="button" class="btn btn-secondary btn-sm" (click)="reset()">Reset</button>
                          </div>
                        </div>
                      </form>
                      
                </div>
            </div>
        </div>
    </div>
    <div class="card card-body">
        <div class="row clearSearch">
            <button type="button" class="btn btn-cancel btn-sm" (click)="clearSearch()" aria-label="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-x"
                    viewBox="0 0 15 15">
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Filter</button>
        </div>
        <div class="col-lg-6">
            <div class="row newReload">
                <div class="pl-4 mb-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-arrow-repeat pointer reload" viewBox="0 0 16 16" (click)="getHolidayList()">
                        <title>Reload</title>
                        <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                        <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                    </svg>
                </div>
            </div>
        </div>
        @if(showDataTable){
        <div class="table-responsive">
            <table id="holidayList" class="table common-table" datatable [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th class="pre-wrap">Sr No</th>
                        <th class="pre-wrap">Year</th>
                        <th class="pre-wrap">Currency</th>
                        <th class="pre-wrap">Date</th>
                        <th class="pre-wrap">Day</th>
                        <th class="pre-wrap">Type</th>
                        <th class="pre-wrap">Description</th>
                        <th class="pre-wrap">Status</th>
                        <th class="pre-wrap">Edit</th>
                        <th class="pre-wrap">Action</th>
                    </tr>
                    <tr class="column-search">
                        <th></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of holidayList;let i=index">
                        <td>{{i+1}}</td>
                        <td class="nocase">{{data.hldYear}}</td>
                        <td>{{data.currencySegment}}</td>
                        <td>{{data.hldDate|date:'mediumDate'}}</td>
                        <td>{{data.hldDay}}</td>
                        <td>{{data.hldType}}</td>
                        <td>{{data.hldDesc}}</td>
                        <td>{{data.hldRevokeFlag=='Y'?'Revoked':'Active'}}</td>
                        <td>
                            <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#addHoliday"
                                (click)="editHoliday(data.hldMasterID)">Edit</button>
                        </td>
                        <td>
                            <button *ngIf="data.hldRevokeFlag=='N'" class="btn btn-secondary ml-2" type="button"
                                data-toggle="modal" data-target="#revokeActivateHoliday"
                                (click)="revokeActivateHoliday(data.hldMasterID, 'Revoke')">Revoke</button>
                            <button *ngIf="data.hldRevokeFlag=='Y'" class="btn btn-primary ml-2" type="button"
                                data-toggle="modal" data-target="#revokeActivateHoliday"
                                (click)="revokeActivateHoliday(data.hldMasterID,'Activate')">Activate</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }
    </div>
</div>

<div class="modal fade" id="revokeActivateHoliday" tabindex="-1" role="dialog"
    aria-labelledby="revokeActivateHolidayModalLongTitle" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body text-center">
                <h4 class="modal-title">Are you sure you want to {{action}} holiday ?</h4>
            </div>
            <div class="d-flex justify-content-center mb-3">
                <div class="col-3"><button type="button" class="btn btn-primary" data-dismiss="modal"
                        (click)="revokeActivateConfirm()">Confirm </button></div>
                <div class="col-3"><button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="addHoliday" tabindex="-1" role="dialog" aria-labelledby="addHolidayModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body">
                <form [formGroup]="addHolidayForm">
                    <div class="row">
                        <div class="col-lg-12 form-group">
                            <label>Holiday Date<span class="red">*</span></label>
                            <div class="input-group">
                                <input type="text" class="form-control form-control-sm datepicker"
                                    formControlName="hldDate" bsDatepicker [(bsValue)]="bsValue1"
                                    placeholder="Select Holiday Date" (ngModelChange)="setHolidayDate()"
                                    [ngClass]="{'is-invalid': hf.hldDate.touched && hf.hldDate.errors}">
                                <div class="input-group-append pointer">
                                    <span class="input-group-text">
                                        <i class="fa fa-calendar" bsDatepicker [(bsValue)]="bsValue1"
                                            [bsConfig]="{ isAnimated: true }"></i>
                                    </span>
                                </div>
                            </div>
                            <p *ngIf="hf.hldDate.touched && hf.hldDate.invalid" class="error">
                                Please select Holiday Date
                            </p>
                        </div>
                        <div class="col-lg-12 form-group">
                            <label>Holiday Type<span class="red">*</span></label>
                            <select class="form-control form-control-sm selectpicker" formControlName="hldType"
                                title="Select Holiday Type"
                                [ngClass]="{'is-invalid': hf.hldType.touched && hf.hldType.errors}">
                                <option value="" disabled>Select Holiday Type</option>
                                <option *ngFor="let data of holidayTypes" value="{{data}}">
                                    {{data}}
                                </option>
                            </select>
                            <p *ngIf="hf.hldType.touched && hf.hldType.invalid" class="error">
                                Please select Holiday Type
                            </p>
                        </div>
                        <div class="col-lg-12 form-group">
                            <label>Currency Segment<span class="red">*</span></label>
                            <select class="form-control form-control-sm selectpicker" formControlName="currencySegment"
                                title="Select Currency Segment"
                                [ngClass]="{'is-invalid': hf.currencySegment.touched && hf.currencySegment.errors}">
                                <option value="" disabled>Select Currency Segment</option>
                                <option *ngFor="let data of currencyList" value="{{data.currencyCode}}">
                                    {{data.currencyCode +" - "+ data.currency}}
                                </option>
                            </select>
                            <p *ngIf="hf.currencySegment.touched && hf.currencySegment.invalid" class="error">
                                Please select Currency Segment
                            </p>
                        </div>
                        <div class="col-lg-12 form-group">
                            <label>Description<span class="red">*</span></label>
                            <input type="text" class="form-control form-control-sm" formControlName="hldDesc"
                                [ngClass]="{'is-invalid': hf.hldDesc.touched && hf.hldDesc.errors}">
                            <p *ngIf="hf.hldDesc.touched && hf.hldDesc.invalid" class="error">
                                Please enter description
                            </p>
                        </div>
                    </div>
                </form>
                <div class="d-flex justify-content-center mt-3">
                    <button type="button" class="btn btn-primary" (click)="saveHolidayMaster()">Add
                        Holiday</button>
                    <button type="button" class="btn btn-secondary ml-2" data-dismiss="modal"
                        (click)="resetHolidayForm()">Cancel</button>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="modal fade" id="bulkUpload" tabindex="-1" role="dialog" aria-labelledby="bulkUploadModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body">
                <div class="card card-body">
                    <div class="row">
                        <div class="col-lg-4">
                            <label class="form-label">Upload File</label>
                            <div class="upload-box text-center form-control-sm" (click)="fileInput.click()"
                                (dragover)="onDragOver($event)" (drop)="onDrop($event)"
                                style="border: 1px solid #ced4da; border-radius: 0.25rem; padding: 0.25rem 0.5rem; cursor: pointer; height: calc(1.5em + 0.5rem + 2px);">
                                <input type="file" formControlName="file" #fileInput hidden (change)="onChange($event)"
                                    accept=".xlsx,.xls,.csv" />
                                <p class="text-muted m-0" *ngIf="!fileName" style="font-size: 0.875rem;">Drop
                                    Excel/CSV</p>
                                <p class="text-primary m-0 text-truncate" *ngIf="fileName" style="font-size: 0.875rem;">
                                    {{fileName}}</p>
                            </div>
                        </div>
                        <div *ngIf="fileName" class="col-lg-4">
                            <label>Attached file</label>
                            <p>{{fileName}}
                                <span class="ml-2">
                                    <svg (click)="removeFile()" xmlns="http://www.w3.org/2000/svg" width="16"
                                        height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                                    </svg>
                                </span>
                            </p>
                        </div>
                        <div class="col-lg-4">
                            <button class="btn btn-link" (click)="downloadExcelFile()" type="button">Download Sample
                                File</button>
                        </div>
                    </div>
                </div>

                <div class="card card-body" *ngIf="this.holidayMasterList.length > 0">
                    <!-- <table class="table common-table ">
                            <thead>
                                <tr>
                                    <th class="pre-wrap">Sr No</th>
                                    <ng-container *ngFor="let data of fileHeaderMap|keyvalue:returnZero">
                                        <th class="pre-wrap" *ngIf="data.key!='ID'">{{data.key}}</th>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody formArrayName="holidayUploadList">
                                <tr *ngFor="let data of holidayUploadForm.controls.holidayUploadList['controls']; let i=index"
                                    [formGroupName]="i">
                                    <td>{{i+1}}</td>
                                    <ng-container *ngFor="let data1 of fileHeaderMap|keyvalue:returnZero">
                                        <td *ngIf="data1.key!='ID'">
                                            <input *ngIf="data1.value.fieldType=='text'" type="text"
                                                class="form-control form-control-sm"
                                                formControlName="{{data1.value.prop}}"
                                                [ngClass]="{'is-invalid':getError(i, data1.key)}">
                                            <input *ngIf="data1.value.fieldType=='number'" type="number"
                                                class="form-control form-control-sm"
                                                formControlName="{{data1.value.prop}}"
                                                [ngClass]="{'is-invalid':getError(i, data1.key)}">
                                            <div class="input-group input-group-sm"
                                                *ngIf="data1.value.fieldType=='date'">
                                                <input type="text" class="form-control form-control-sm datepicker"
                                                    formControlName="{{data1.value.prop}}" bsDatepicker
                                                    [(bsValue)]="holidayUploadForm.controls.holidayUploadList['controls'][i].controls[data1.value.prop].value"
                                                    placeholder="Select {{data1.key}}"
                                                    [ngClass]="{'is-invalid':getError(i, data1.key) || holidayUploadForm.controls.holidayUploadList['controls'][i].controls[data1.value.prop].invalid}">
                                                <div class="input-group-append pointer">
                                                    <span class="input-group-text">
                                                        <i class="fa fa-calendar" bsDatepicker
                                                            [(bsValue)]="holidayUploadForm.controls.holidayUploadList['controls'][i].controls[data1.value.prop].value"
                                                            [bsConfig]="{ isAnimated: true }"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <select *ngIf="data1.value.fieldType=='select'"
                                                class="form-control form-control-sm selectpicker"
                                                formControlName="{{data1.value.prop}}" title="Select {{data1.key}}"
                                                [ngClass]="{'is-invalid':getError(i, data1.key)}">
                                                <option value="" disabled>Select {{data1.key}}</option>
                                                <option *ngFor="let data of data1.value.oneOf" value="{{data}}">{{data}}
                                                </option>
                                            </select>
                                            <small *ngIf="data1.value.type.name=='Number'" class="text-muted">
                                                {{data.controls[data1.value.prop].value?toWords.convert(data.controls[data1.value.prop].value):''}}
                                            </small>
                                            <span *ngIf="getError(i, data1.key)" class="error">
                                                Please enter valid {{data1.key}}
                                            </span>
                                        </td>
                                    </ng-container>
                                </tr>
                            </tbody>
                        </table> -->
                    <div class="table-responsive">
                        <table id="holidayMasterTable" class="table common-table" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger">
                            <thead>
                                <tr>
                                    <th class="pre-wrap">Sr No</th>
                                    <th class="pre-wrap">Year</th>
                                    <th class="pre-wrap">Currency</th>
                                    <th class="pre-wrap">Date</th>
                                    <th class="pre-wrap">Day</th>
                                    <th class="pre-wrap">Type</th>
                                    <th class="pre-wrap">Description</th>

                                </tr>
                                <tr class="column-search">
                                    <th></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>
                                    <th><input type="text" class="form-control form-control-sm" /></th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of holidayMasterList;let i=index">
                                    <td>{{i+1}}</td>
                                    <td class="nocase">{{data.hldYear}}</td>
                                    <td>{{data.currencySegment}}</td>
                                    <td>{{data.hldDate|date:'mediumDate'}}</td>
                                    <td>{{data.hldDay}}</td>
                                    <td>{{data.hldType}}</td>
                                    <td>{{data.hldDesc}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal"
                    (click)="saveHolidayUpload()">Save</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal"
                    (click)="closeModel()">Cancel</button>
            </div>
        </div>
    </div>
</div>